import loadable from '@loadable/component';

export const AsyncRecommendedProperties = loadable(() =>
    import(
        /* webpackChunkName: "recommended-properties" */
        /* webpackPrefetch: true */
        './'
    )
);

AsyncRecommendedProperties.displayName = 'AsyncRecommendedProperties';
